import { render, staticRenderFns } from "./SpecListChoose.vue?vue&type=template&id=b420b598&scoped=true"
import script from "./SpecListChoose.vue?vue&type=script&lang=js"
export * from "./SpecListChoose.vue?vue&type=script&lang=js"
import style0 from "./SpecListChoose.vue?vue&type=style&index=0&id=b420b598&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b420b598",
  null
  
)

export default component.exports